/** @format */

export interface HomrCta {
  link: string;
  linkTitle: string;
}

export type HomrCtaSet = HomrCta[] | [Record<string, never>];
